import moment from 'moment'
import 'moment/locale/ru'
import { IWithdrawalRequest } from 'models/withdrawalRequest'

type TWithdrawalPeriodSource = Pick<IWithdrawalRequest, 'period_start' | 'period_end' | 'createdAt'>

const formatDay = (day: moment.Moment) => day.locale('ru').format('D MMMM YYYY')

// Период бэкенд проставляет и старым заявкам, без него заявка приходит только от необновлённого бэкенда
export const getWithdrawalPeriodDays = ({ period_start, period_end, createdAt }: TWithdrawalPeriodSource) => {
  if (!period_start || !period_end) {
    return [formatDay(moment(createdAt))]
  }

  return [formatDay(moment(period_start, 'YYYY-MM-DD')), formatDay(moment(period_end, 'YYYY-MM-DD'))]
}
